// extracted by mini-css-extract-plugin
module.exports = {"closeCross":"LookBoardItem_closeCross__3bnVW"};